<template>
  <Chart :options="chartOptions"></Chart>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import more from "highcharts/highcharts-more";
import { computed, toRefs } from "vue";
more(Highcharts);

export default {
  components: { Chart },
  props: {
    series: {
      type: Array,
      default: () => [],
    },
    titleText: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },

    width: {
      type: Number,
      default: 70,
    },
    height: {
      type: Number,
      default: 70,
    },
    colors: {
      type: Array,
      default: () => ["#00C875", "#696D82", "#0085FF"],
    },
    hasMouseTracking: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    // generate props data
    const {
      series,
      titleText,
      subtitle,
      width,
      height,
      colors,
      hasMouseTracking,
    } = toRefs(props);
    const chartOptions = computed(() => {
      return {
        chart: {
          style: {
            fontFamily: "iranyekan",
          },
          type: "pie",
          width: width.value,
          height: height.value,
          margin: 0,
          spacing: [0, 0, 0, 0],
          backgroundColor: "transparent",
        },
        colors: colors.value,
        title: {
          enabled: false,
          text: titleText.value,
          align: "left",
        },
        subtitle: {
          text: subtitle.value,
          align: "left",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          series: {
            enableMouseTracking: hasMouseTracking.value,
            dataLabels: {
              enabled: false,
              format: "{point.name}: {point.y:.1f}%",
            },
          },
        },
        tooltip: {
          enabled: false,
          headerFormat: "",
          pointFormat: "",
        },
        series: [
          {
            name: "",
            colorByPoint: true,
            groupPadding: 0,
            data: series.value,
          },
        ],
      };
    });

    // return data to be used in template
    return { chartOptions };
  },
};
</script>
